import React, { Component } from 'react';
import {Link} from 'react-router-dom';
import logo from '../faf_logo_new.jpg';
import styled from 'styled-components';
import {ButtonContainer} from './Button';

export default class Navbar extends Component {
    render () {
        return (
            <NavWrapper className='navbar navbar-expand-sm fixed-top topnav' id="myTopnav">
                <Link to='/'>
                    <img src={logo} alt="Home" className="navbar-brand img-icon" />
                </Link>        
                <Link to='/donate' className="ml-1 ml-sm-1">
                    <ButtonContainer cart>Donate</ButtonContainer>
                </Link>
                <Link to='/carts' className="ml-1">
                    <ButtonContainer>
                        <span className="mr-2">
                            <i className="fas fa-cart-plus" />
                        </span>
                        My cart
                    </ButtonContainer>
                </Link>
                <ul className="navbar-nav align-items-center navlink">
                        <li className="navbar-item ml-lg-1 ml-md-3">
                            <Link to='/' className="nav-link navlink" title="FA-Foundation Home">
                            <i className="fas fa-home home mr-md-3" /><span className="mr-3 resize"> Home</span>
                            </Link>
                        </li>
                        <li className="navbar-item ml-lg-3 ml-md-3">
                            <Link to='/store' className="nav-link navlink" title="FA-Foundation Products">
                            <i className="fab fa-shopify shop" /><span className="mr-3  mr-md-3 resize"> Store</span>
                            </Link>
                        </li>
                    </ul>
                    {/*
                    <Link to="/" className="icon navlink" 
                    onClick={
                        ()=> {
                            var x = document.getElementById("myTopnav");
                            if (x.className === "topnav") {
                            x.className += " responsive";
                            } else {
                            x.className = "topnav";
                            }
                        }
                    }
                    >
                        <i class="fa fa-bars"></i>
                    </Link>
                    */}            
            </NavWrapper>
        )
    }
}

const NavWrapper = styled.nav`
background: var(--mainWhite);
.nav-link {
    color: var(--mainBlue) !important;
    font-size: 1.0rem;
    text-transform: capitalise;
}
`;